import { type ExtraValues, type PlatformEvent } from '../types';

export const adIsStartedEvent = (extra: ExtraValues): PlatformEvent => {
  return {
    type: 'ad',
    created: Date.now(),
    user_properties: {
      ...(extra && { ...extra.user_properties }),
    },
    event_properties: {
      name: 'view_started',
      ...extra.event_properties,
    },
  };
};
